module.exports = __webpack_public_path__ + "static/media/machine_test.c33ca8eb.jpg";